import { connect } from '@atlassian/jira-react-redux';
import { projectNameSelector } from '../../state/entities/selectors';
import type { AppState } from '../../state/types';
import { dismissFlag } from '../../state/ui/actions';
import { flagsSelector, validationErrorsSelector } from '../../state/ui/selectors';
import Flags, { type StateProps, type DispatchProps } from './view';

const mapStateToProps = (state: AppState): StateProps => ({
	flags: flagsSelector(state),
	projectName: projectNameSelector(state),
	validationErrors: validationErrorsSelector(state),
});

const mapDispatchToProps: DispatchProps = {
	onDismissed: dismissFlag,
};

export default connect(mapStateToProps, mapDispatchToProps)(Flags);
